import React from 'react';
import { MdVerified } from 'react-icons/md';
import { checkSubscription } from '../../utils/checkSubscription';
import findUserRank from '../../utils/findUserRank';
import styles from './VerifiedBadge.module.css';

const VerifiedBadge = ({ userPlan, totalXP, showRank = true, size = 'default' }) => {
	const isPremium = checkSubscription({ userPlan });
	if (!isPremium) return null;

	const rank = showRank && totalXP != null ? findUserRank(totalXP) : null;
	const sizeClass = size === 'small' ? styles.Small : size === 'large' ? styles.Large : '';

	return (
		<span className={`${styles.Badge} ${sizeClass}`}>
			<MdVerified className={styles.CheckIcon} />
			{rank && <span className={styles.RankEmoji}>{rank.emoji}</span>}
		</span>
	);
};

export default VerifiedBadge;
